module.exports = {
    os: {
        win: 'win',
        mac: 'mac',
        android: 'android',
        ios: 'ios',
        winPhone: 'win-phone'
    },
    browser: {
        ie8: 'ie8',
        ie9: 'ie9',
        ie10: 'ie10',
        ie11: 'ie11',
        chrome: 'chrome',
        firefox: 'firefox',
        safari: 'safari',
        edge: 'edge'
    }
};


/** WEBPACK FOOTER **
 ** ./src/constants/platforms.js
 **/